<template>
    <div>
        <h1>Lista de Clientes</h1>
        <select v-model="clienteSeleccionado">
            <option value="">Seleccionar Cliente</option>
            <option v-for="cliente in Customers" :key="cliente.id" :value="cliente.id">
                {{ cliente.nombres }} {{ cliente.apellidoPaterno }} {{ cliente.apellidoMaterno }}
            </option>
        </select>

        <div v-if="clienteSeleccionado">
            <h2>Información del Cliente</h2>
            <p>Nombre: {{ clienteInfo.nombres }} {{ clienteInfo.apellidoPaterno }} {{ clienteInfo.apellidoMaterno }}</p>
            <p>Fecha de Nacimiento: {{ clienteInfo.fechaNacimiento }}</p>
            <p>CURP: {{ clienteInfo.curp }}</p>
            <p>RFC: {{ clienteInfo.rfc }}</p>
            <p>Teléfono: {{ clienteInfo.telefono }}</p>
            <p>Email: {{ clienteInfo.email }}</p>
            <p>Cruzamiento 1: {{ clienteInfo.cruzamiento1 }}</p>
            <p>Cruzamiento 2: {{ clienteInfo.cruzamiento2 }}</p>
            <p>Número Interior: {{ clienteInfo.numeroInterior }}</p>
            <p>Número Exterior: {{ clienteInfo.numeroExterior }}</p>
            <p>Código Postal: {{ clienteInfo.codigoPostal }}</p>
            <p>País: {{ clienteInfo.pais }}</p>
            <p>Entidad: {{ clienteInfo.entidad }}</p>
            <p>Municipio: {{ clienteInfo.municipio }}</p>
            <p>Localidad: {{ clienteInfo.localidad }}</p>
            <p>Colonia: {{ clienteInfo.colonia }}</p>
            <!-- Agrega más campos aquí según tus necesidades -->
        </div>
    </div>
</template>
  
<script>
import { ref, onUnmounted } from "vue";
import {
    db,
    collection,
    doc,
    deleteDoc,
    setDoc,
    addDoc,
    orderBy,
    query,
    onSnapshot,
} from "../../firebase/index.js";

export default {
    data() {
        return {
            Customers: [],
            clienteSeleccionado: "", // Variable para almacenar el ID del cliente seleccionado
            clienteInfo: {}, // Variable para almacenar la información del cliente seleccionado
        };
    },
    methods: {
        obtieneInfo() {
            const latestQuery = query(collection(db, "Customers"), orderBy("date"));
            this.liveCustomers = onSnapshot(latestQuery, (snapshot) => {
                this.Customers = snapshot.docs.map((doc) => ({
                    id: doc.id,
                    nombres: doc.data().nombres,
                    apellidoPaterno: doc.data().apellidoPaterno,
                    apellidoMaterno: doc.data().apellidoMaterno,
                    fechaNacimiento: doc.data().fechaNacimiento,
                    curp: doc.data().curp,
                    rfc: doc.data().rfc,
                    telefono: doc.data().telefono,
                    email: doc.data().email,
                    cruzamiento1: doc.data().cruzamiento1,
                    cruzamiento2: doc.data().cruzamiento2,
                    numeroInterior: doc.data().numeroInterior,
                    numeroExterior: doc.data().numeroExterior,
                    codigoPostal: doc.data().codigoPostal,
                    pais: doc.data().pais,
                    entidad: doc.data().entidad,
                    municipio: doc.data().municipio,
                    localidad: doc.data().localidad,
                    colonia: doc.data().colonia,
                }));
            });
        },
    },
    watch: {
        clienteSeleccionado(newValue) {
            // Buscar la información del cliente seleccionado y asignarla a clienteInfo
            this.clienteInfo = this.Customers.find((cliente) => cliente.id === newValue);
        },
    },
    mounted() {
        this.obtieneInfo();
    },
};
</script>
  